import { useCallback, useRef } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Label } from '@hivebrite/design-system/Label';

import { useJobContext } from 'hb-react/shared/apps/JobForm/contexts/JobContext';
import { type QuillEditorV3Ref } from 'hb-react/shared/components/DesignSystem/QuillEditor/types';
import QuillEditorWrappedV3 from 'hb-react/shared/components/QuillEditorWrappedV3';
import isInBO from 'hb-react/shared/utils/isInBO';

export const Description = () => {
  const { colors } = useJobContext();

  const inBO = isInBO();

  const CONTENT = 'content';
  const quillEditorRef = useRef<QuillEditorV3Ref | null>(null);

  const onClick = useCallback(() => {
    if (quillEditorRef && quillEditorRef.current) {
      quillEditorRef.current.focus();
    }
  }, [quillEditorRef]);

  return (
    <Box display="block" pb={6}>
      <Label id={CONTENT} required wrapperProps={{ onClick }}>
        {s__('JobForm|Description')}
      </Label>
      <QuillEditorWrappedV3
        ariaLabelledBy={__('Description')}
        id={CONTENT}
        isRequired
        minHeight={250}
        name={CONTENT}
        options={{
          toolbar: {
            bold: true,
            italic: true,
            links: true,
            list_bullet: true,
            list_ordered: true,
            mentions: false,
            underline: true,
            color: inBO && { customColors: colors },
            header: true,
          },
        }}
        ref={quillEditorRef}
      />
    </Box>
  );
};
